import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Send, Loader2 } from "lucide-react";
import SignalChannel from "@/components/signals/SignalChannel";

// Standalone member Topics module. Opens the sponsoring IB's broadcast directly
// (read-only) using the existing shared resolver + SignalChannel. Supports the
// backward-compatible notification deep-link (?topic=<id>&msg=<id>).
export default function MemberTopics() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [signal, setSignal] = useState(null);
  const [focus, setFocus] = useState(null);
  const [ibName, setIbName] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/member/activity/signals");
        if (!cancelled) setIbName(r.data?.ib_name || "");
      } catch { /* ignore — header name is cosmetic */ }
      const topic = params.get("topic");
      const msg = params.get("msg");
      if (topic) {
        if (!cancelled) { setSignal({ id: topic }); setFocus(msg || null); setLoading(false); }
        return;
      }
      try {
        const r = await api.get("/member/activity/signals/broadcast");
        if (!cancelled) setSignal(r.data?.id ? { id: r.data.id } : null);
      } catch {
        if (!cancelled) setSignal(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = () => navigate("/member");

  return (
    <div className="min-h-[60vh]" data-testid="member-topics-page">
      {loading ? (
        <div className="flex items-center justify-center py-24" data-testid="member-topics-loading">
          <Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" />
        </div>
      ) : signal ? (
        <SignalChannel signal={{ ...signal, ib_name: ibName }} mode="member"
          focusMessageId={focus}
          onClose={close} onChanged={() => {}} />
      ) : (
        <div className="max-w-md mx-auto text-center card-lux p-10 mt-10" data-testid="member-topics-empty">
          <div className="h-12 w-12 mx-auto rounded-full bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center mb-4">
            <Send className="h-5 w-5 text-emerald-400" />
          </div>
          <p className="text-white font-medium">No broadcast yet</p>
          <p className="text-sm text-[#64748B] mt-1.5">Your IB hasn't posted any topics yet. Check back soon.</p>
          <button onClick={close} className="mt-6 text-sm text-[#D4AF37] hover:text-[#F4E3A1]" data-testid="member-topics-empty-back">Back to dashboard</button>
        </div>
      )}
    </div>
  );
}
